import React from 'react';

const num = (v) => Number(v || 0).toLocaleString(undefined, { maximumFractionDigits: 2 });
const usd = (v) => `$${Number(v || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const usd0 = (v) => `$${Math.round(Number(v || 0)).toLocaleString()}`;

const Tile = ({ label, value, testid }) => (
  <div className="px-4 py-2 min-w-[120px]">
    <p className="text-[10px] uppercase tracking-wider text-[#737373]">{label}</p>
    <p data-testid={testid} className="text-white font-semibold text-lg leading-tight tabular-nums">{value}</p>
  </div>
);

// Totals for the full filtered result set (server-computed), not just the visible page.
export const InventorySummaryStrip = ({ s, scopeLabel }) => (
  <div data-testid="inv-summary-strip" className="flex flex-wrap items-stretch gap-3">
    <div className="flex flex-wrap divide-x divide-[#262626] rounded-md border border-[#262626] bg-[#141414]">
      <Tile label={`${scopeLabel}Items`} value={num(s?.items)} testid="inv-summary-items" />
      <Tile label={`${scopeLabel}Shop + WH Qty`} value={num(s?.controlled_qty)} testid="inv-summary-controlled-qty" />
      <Tile label={`${scopeLabel}Shop + WH Cost`} value={usd(s?.controlled_value)} testid="inv-summary-controlled-value" />
    </div>
    <div className="rounded-md border border-dashed border-[#404040] bg-transparent px-4 py-2 min-w-[170px]" title="Rough estimate only — never included in exact company totals, low stock or reorder.">
      <p className="text-[10px] uppercase tracking-wider text-[#737373]">Estimated On Van <span className="normal-case tracking-normal text-[#525252]">· rough</span></p>
      <p data-testid="inv-summary-van-estimated" className="text-[#A3A3A3] font-medium text-lg leading-tight tabular-nums italic">~{num(s?.van_estimated_qty)} units · ~{usd0(s?.van_estimated_value)}</p>
    </div>
  </div>
);

export default InventorySummaryStrip;
